module.exports = __webpack_public_path__ + "img/settings3.cfa12d9d.png";